export default function roomRateName(roomType, roomRate) {
  return `${roomType.name} - ${roomRate.rate_plan.name}`;
}
